const CDN_URL = "https://cdn.tagg.live/emotion-design/images";

export const cdnImages = {
  caseStudy: {
    coverImg: {
      caseStudy1: `${CDN_URL}/case-study/cover/caseStudy1.webp`,
      caseStudy2: `${CDN_URL}/case-study/cover/caseStudy2.webp`,
      caseStudy3: `${CDN_URL}/case-study/cover/caseStudy3.webp`,
      caseStudy4: `${CDN_URL}/case-study/cover/caseStudy4.webp`,
    },
    coverVid: {
      caseStudy1: `${CDN_URL}/case-study/cover/caseStudy1.webm`,
      caseStudy2: `${CDN_URL}/services-media/supreme-court-video-optimized.webm`,
      caseStudy3: `${CDN_URL}/case-study/cover/caseStudy3.webm`,
      caseStudy4: `${CDN_URL}/case-study/cover/caseStudy4.webm`,
    },
    thumbnails: {
      caseStudy1: `${CDN_URL}/case-study/thumbnails/thumbnail1.webp`,
      caseStudy2: `${CDN_URL}/case-study/thumbnails/thumbnail2.webp`,
      caseStudy3: `${CDN_URL}/case-study/thumbnails/thumbnail3.webp`,
      caseStudy4: `${CDN_URL}/case-study/thumbnails/thumbnail4.webp`,
      caseStudy5: `${CDN_URL}/case-study/thumbnails/thumbnail5.webp`,
      caseStudy6: `${CDN_URL}/case-study/thumbnails/thumbnail6.webp`,
    },
    subHeader: {
      caseStudy1: `${CDN_URL}/case-study/sub-header/caseStudy1.webp`,
      caseStudy2: `${CDN_URL}/case-study/sub-header/caseStudy2.webp`,
      caseStudy3: `${CDN_URL}/case-study/sub-header/caseStudy3.webp`,
      caseStudy4: `${CDN_URL}/case-study/sub-header/caseStudy4.webp`,
    },
    subProjects: {
      caseStudy1: {
        img1: `${CDN_URL}/case-study/sub-projects/case-study1/img1.webp`,
        img2: `${CDN_URL}/case-study/sub-projects/case-study1/img2.webp`,
      },
      caseStudy2: {
        img1: `${CDN_URL}/case-study/sub-projects/case-study2/img1.webp`,
        img2: `${CDN_URL}/case-study/sub-projects/case-study2/img2.webp`,
      },
      caseStudy3: {
        img1: `${CDN_URL}/case-study/sub-projects/case-study3/img1.webp`,
        img2: `${CDN_URL}/case-study/sub-projects/case-study3/img2.webp`,
      },
      caseStudy4: {
        img1: `${CDN_URL}/case-study/sub-projects/case-study4/img1.webp`,
        img2: `${CDN_URL}/case-study/sub-projects/case-study4/img2.webp`,
      },
    },
    impact: {
      caseStudy1: `${CDN_URL}/case-study/impact/caseStudy1.webm`,
      caseStudy2: `${CDN_URL}/case-study/impact/caseStudy2.webm`,
      caseStudy3: `${CDN_URL}/case-study/impact/caseStudy3.webm`,
      caseStudy4: `${CDN_URL}/case-study/impact/caseStudy4.webm`,
    },
    process: {
      caseStudy1: {
        img1: `${CDN_URL}/case-study/process/case-study1/img1.webp`,
        img2: `${CDN_URL}/case-study/process/case-study1/img2.webp`,
        img3: `${CDN_URL}/case-study/process/case-study1/img3.webp`,
        img4: `${CDN_URL}/case-study/process/case-study1/img4.webp`,
        img5: `${CDN_URL}/case-study/process/case-study1/img5.webp`,
      },
      caseStudy2: {
        img1: `${CDN_URL}/case-study/process/case-study2/img1.webp`,
        img2: `${CDN_URL}/case-study/process/case-study2/img2.webp`,
        img3: `${CDN_URL}/case-study/process/case-study2/img3.webp`,
        img4: `${CDN_URL}/case-study/process/case-study2/img4.webp`,
        img5: `${CDN_URL}/case-study/process/case-study2/img5.webp`,
      },
      caseStudy3: {
        img1: `${CDN_URL}/case-study/process/case-study3/img1.webp`,
        img2: `${CDN_URL}/case-study/process/case-study3/img2.webp`,
        img3: `${CDN_URL}/case-study/process/case-study3/img3.webp`,
        img4: `${CDN_URL}/case-study/process/case-study3/img4.webp`,
        img5: `${CDN_URL}/case-study/process/case-study3/img5.webp`,
      },
      caseStudy4: {
        img1: `${CDN_URL}/case-study/process/case-study4/img1.webp`,
        img2: `${CDN_URL}/case-study/process/case-study4/img2.webp`,
        img3: `${CDN_URL}/case-study/process/case-study4/img3.webp`,
        img4: `${CDN_URL}/case-study/process/case-study4/img4.webp`,
        img5: `${CDN_URL}/case-study/process/case-study4/img5.webp`,
      },
    },
    keyLearnings: {
      caseStudy1: `${CDN_URL}/case-study/key-learnings/caseStudy1.webp`,
      caseStudy2: `${CDN_URL}/case-study/key-learnings/caseStudy2.webp`,
      caseStudy3: `${CDN_URL}/case-study/key-learnings/caseStudy3.webp`,
      caseStudy4: `${CDN_URL}/case-study/key-learnings/caseStudy4.webp`,
    },
    awards: {
      caseStudy1: {
        award1: `${CDN_URL}/case-study/awards/case-study1/img1.webp`,
        award2: `${CDN_URL}/case-study/awards/case-study1/img2.webp`,
        award3: `${CDN_URL}/case-study/awards/case-study1/img3.webp`,
        award4: `${CDN_URL}/case-study/awards/case-study1/img4.webp`,
        award5: `${CDN_URL}/case-study/awards/case-study1/img5.webp`,
        award6: `${CDN_URL}/case-study/awards/case-study1/img6.webp`,
        award7: `${CDN_URL}/case-study/awards/case-study1/img7.webp`,
        award8: `${CDN_URL}/case-study/awards/case-study1/img8.webp`,
        award9: `${CDN_URL}/case-study/awards/case-study1/img9.webp`,
        award10: `${CDN_URL}/case-study/awards/case-study1/img10.webp`,
        award11: `${CDN_URL}/case-study/awards/case-study1/img11.webp`,
        award12: `${CDN_URL}/case-study/awards/case-study1/img12.webp`,
      },
      caseStudy3: {
        award1: `${CDN_URL}/case-study/awards/case-study3/img1.webp`,
        award2: `${CDN_URL}/case-study/awards/case-study3/img2.webp`,
      },
    },
    gallery: {
      caseStudy1: {
        gallery1: `${CDN_URL}/case-study/gallery/case-study1/gallery1.webp`,
        gallery2: `${CDN_URL}/case-study/gallery/case-study1/gallery2.webp`,
        gallery3: `${CDN_URL}/case-study/gallery/case-study1/gallery3.webp`,
        gallery4: `${CDN_URL}/case-study/gallery/case-study1/gallery4.webp`,
        gallery5: `${CDN_URL}/case-study/gallery/case-study1/gallery5.webp`,
        gallery6: `${CDN_URL}/case-study/gallery/case-study1/gallery6.webp`,
        gallery7: `${CDN_URL}/case-study/gallery/case-study1/gallery7.webp`,
        gallery8: `${CDN_URL}/case-study/gallery/case-study1/gallery8.webp`,
        gallery9: `${CDN_URL}/case-study/gallery/case-study1/gallery9.webp`,
      },
      caseStudy2: {
        gallery1: `${CDN_URL}/case-study/gallery/case-study2/gallery1.webp`,
        gallery2: `${CDN_URL}/case-study/gallery/case-study2/gallery2.webp`,
        gallery3: `${CDN_URL}/case-study/gallery/case-study2/gallery3.webp`,
        gallery4: `${CDN_URL}/case-study/gallery/case-study2/gallery4.webp`,
        gallery5: `${CDN_URL}/case-study/gallery/case-study2/gallery5.webp`,
        gallery6: `${CDN_URL}/case-study/gallery/case-study2/gallery6.webp`,
        gallery7: `${CDN_URL}/case-study/gallery/case-study2/gallery7.webp`,
        gallery8: `${CDN_URL}/case-study/gallery/case-study2/gallery8.webp`,
        gallery9: `${CDN_URL}/case-study/gallery/case-study2/gallery9.webp`,
      },
      caseStudy3: {
        gallery1: `${CDN_URL}/case-study/gallery/case-study3/gallery1.webp`,
        gallery2: `${CDN_URL}/case-study/gallery/case-study3/gallery2.webp`,
        gallery3: `${CDN_URL}/case-study/gallery/case-study3/gallery3.webp`,
        gallery4: `${CDN_URL}/case-study/gallery/case-study3/gallery4.webp`,
        gallery5: `${CDN_URL}/case-study/gallery/case-study3/gallery5.webp`,
        gallery6: `${CDN_URL}/case-study/gallery/case-study3/gallery6.webp`,
        gallery7: `${CDN_URL}/case-study/gallery/case-study3/gallery7.webp`,
        gallery8: `${CDN_URL}/case-study/gallery/case-study3/gallery8.webp`,
        gallery9: `${CDN_URL}/case-study/gallery/case-study3/gallery9.webp`,
      },
      caseStudy4: {
        gallery1: `${CDN_URL}/case-study/gallery/case-study4/gallery1.webp`,
        gallery2: `${CDN_URL}/case-study/gallery/case-study4/gallery2.webp`,
        gallery3: `${CDN_URL}/case-study/gallery/case-study4/gallery3.webp`,
        gallery4: `${CDN_URL}/case-study/gallery/case-study4/gallery4.webp`,
        gallery5: `${CDN_URL}/case-study/gallery/case-study4/gallery5.webp`,
        gallery6: `${CDN_URL}/case-study/gallery/case-study4/gallery6.webp`,
        gallery7: `${CDN_URL}/case-study/gallery/case-study4/gallery7.webp`,
        gallery8: `${CDN_URL}/case-study/gallery/case-study4/gallery8.webp`,
        gallery9: `${CDN_URL}/case-study/gallery/case-study4/gallery9.webp`,
      },
    },
  },
} as const;
